<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <div v-if="$route.params.type == 'all-ncfs'">
      <b-form-group label="Status">
        <b-form-checkbox
          v-for="option in statusOptions"
          :key="option.value"
          v-model="statusFilterValue"
          :value="option.value"
          name="flavour-3a"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
      <hr class="dividerHR filter-divider">
    </div>
    <b-form-group
      label="Created At"
    >
      <b-input-group>
        <flat-pickr
          v-model="createdAtFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group label="Type">
      <b-form-radio-group
        v-model="typeFilterValue"
        :options="typeRadioOptions"
        name="type-radios-stacked"
        stacked
      />
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group label="Proposed Solution">
      <b-form-checkbox
        v-for="option in solutionOptions"
        :key="option.value"
        v-model="solutionFilterValue"
        :value="option.value"
        name="flavour-3a"
      >
        {{ option.label }}
      </b-form-checkbox>
    </b-form-group>
    <b-button
      variant="outline-primary"
      size="sm"
      class="mr-1"
      @click="clearFilter"
    >
      Clear All
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      @click="applyFilter"
    >
      Apply Filter
    </b-button>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend, BFormCheckbox, BFormRadioGroup,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BFormRadioGroup,
    flatPickr,
  },
  props: {
    statusFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    createdAtFilter: {
      type: [String, null],
      default: null,
    },
    typeFilter: {
      type: [String, null],
      default: null,
    },
    solutionFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      createdAtFilterValue: this.createdAtFilter,
      typeFilterValue: this.typeFilter,
      solutionFilterValue: JSON.parse(JSON.stringify(this.solutionFilter)) || [],
      statusFilterValue: JSON.parse(JSON.stringify(this.statusFilter)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
      solutionOptions: [
        { label: 'Return to External Provider', value: 'Return to External Provider' },
        { label: 'Rework', value: 'Rework' },
        { label: 'Use as it is', value: 'Use as it is' },
        { label: 'Reject', value: 'Reject' },
      ],
      typeRadioOptions: [
        { text: 'Incoming', value: 'Incoming' },
        { text: 'Work-in-progress (WIP)', value: 'Work-in-progress (WIP)' },
      ],
    }
  },
  watch: {
    createdAtFilter: {
      immediate: true,
      handler(val) {
        this.createdAtFilterValue = val
      },
    },
    typeFilter: {
      immediate: true,
      handler(val) {
        this.typeFilterValue = val
      },
    },
    solutionFilter: {
      immediate: true,
      handler(val) {
        this.solutionFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.createdAtFilterValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:createdAt', this.createdAtFilterValue)
      this.$emit('update:solutionFilter', this.solutionFilterValue)
      this.$emit('update:typeFilter', this.typeFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.createdAtFilterValue = ''
      this.typeFilterValue = ''
      this.statusFilterValue = []
      this.solutionFilter = []
      this.$emit('update:solutionFilter', this.solutionFilterValue)
      this.$emit('update:typeFilter', this.typeFilterValue)
      this.$emit('update:createdAt', this.createdAtFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
